import styled from 'styled-components';

import { colorsMatrix, Text } from '@dreryk/react-components';

export const StyledSkipAddressInStampText = styled(Text)`
   color: ${colorsMatrix.grey.dark};
`;

StyledSkipAddressInStampText.displayName = 'StyledSkipAddressInStampText';
